import route from '../utils/route'
import { t } from '../../common/i18n/index'

export interface IAreaPrivadaTab {
  name: string
  route: string
  active: boolean
  icon?: string
}
const makeRegex = pattern => {
  return new RegExp(pattern)
}

const makeTabs = (menutabs?: boolean): IAreaPrivadaTab[] => {
  let tabs
  if (menutabs === true) {
    tabs = [
      {
        name: t('area_privada.tabs.vision_general'),
        route: route('area-privada.index'),
        active: false,
        icon: "area",
      },
      {
        name: t('area_privada.tabs.mi_historia'),
        route: route('historico.index'),
        active: false,
        icon: "historia",
      },
      {
        name: t('area_privada.tabs.mis_datos'),
        route: route('mis-datos.index'),
        active: false,
        icon: "datos",
      },
      {
        name: t('area_privada.tabs.mis_pedidos'),
        route: route('mis-pedidos.index'),
        active: false,
        icon: "pedidos",
      },
      {
        name: t('area_privada.tabs.mis_facturas'),
        route: route('mis-pedidos.index'),
        active: false,
        icon: "facturas",
      },
      { name: t('area_privada.tabs.cerrar'), route: route('index'), icon: "logout" },
    ]
  } else if (typeof window !== 'undefined') {
    tabs = [
      {
        name: t('area_privada.tabs.vision_general'),
        route: route('area-privada.index'),
        active: !!makeRegex(route('area-privada.index')).test(
          window.location.href
        ),
      },
      {
        name: t('area_privada.tabs.mi_historia'),
        route: route('historico.index'),
        active: !!makeRegex(route('historico.index')).test(window.location.href),
      },
      {
        name: t('area_privada.tabs.mis_datos'),
        route: route('mis-datos.index'),
        active: !!makeRegex(route('mis-datos.index')).test(window.location.href),
      },
      {
        name: t('area_privada.tabs.mis_pedidos'),
        route: route('mis-pedidos.index'),
        active: !!makeRegex(route('mis-pedidos.index')).test(
          window.location.href
        ),
      },
      { name: t('area_privada.tabs.salir'), route: route('index') },
    ]
  } else {
    tabs = [
      {
        name: t('area_privada.tabs.vision_general'),
        route: route('area-privada.index'),
        active: false,
      },
      {
        name: t('area_privada.tabs.mi_historia'),
        route: route('historico.index'),
        active: false,
      },
      {
        name: t('area_privada.tabs.mis_datos'),
        route: route('mis-datos.index'),
        active: false,
      },
      {
        name: t('area_privada.tabs.mis_pedidos'),
        route: route('mis-pedidos.index'),
        active: false,
      },
      { name: t('area_privada.tabs.salir'), route: route('index') },
    ]
  }

  return tabs
}

export default makeTabs
